import { render } from "./DocumentListView.vue?vue&type=template&id=18d255e7&scoped=true"
import script from "./DocumentListView.vue?vue&type=script&lang=js"
export * from "./DocumentListView.vue?vue&type=script&lang=js"

import "./DocumentListView.vue?vue&type=style&index=0&id=18d255e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d255e7"]])

export default __exports__